// frete.js: frete por CEP na PDP (snippets/frete-cep) e no drawer e em /cart (snippets/frete-carrinho, L10c). Módulo
// sob demanda; teto de 7 KiB (7.168 B) minificado (decisão do JARVIS de 2026-10-17: fora do caminho do LCP, 30 KB por página).
// Contrato v4: hub/frete-proxy/CONTRATO.md (fonte Frenet, v1b; peso real e valor declarado efetivo, L10g) — POST text/plain, sem cookies, resposta em centavos; qualquer status sem JSON
// = "não foi possível calcular agora". Cada consulta tem número: resposta de consulta antiga é descartada (troca de
// variante ou de CEP). Prazo de 8 s (o serviço desiste da Frenet em 6 s). No máximo 1 cotação a cada 3 s na página.
// CEP lembrado na sessão (sessionStorage, o mesmo na PDP e no carrinho) e recalculado ao abrir outra PDP ou o carrinho.
// Exibição da copy 10f (Econômico / Expresso). L2a (decisão de Henrique, 23/10, decisoes/2026-10-23-calculadora-pdp-so-produto.md):
// a PDP cota SÓ a peça exibida (1 unidade, preço cheio, sem o carrinho e sem o kit); o quanto falta para o frete grátis
// pelo carrinho fica na barra da PDP (snippets/frete-barra-pdp). No carrinho, cota o carrinho pelo total que o Liquid traz.
// A PDP inicia ao carregar; o <details> do carrinho, ao abrir (o core.js importa este módulo e chama iniciar).
// L10a-r2-1 / L10a-r4-1 (Riff): próxima cotação permitida na PÁGINA (PDP e drawer juntos) = instante do último envio
// efetivo + intervalo. Quem acorda confere de novo antes de enviar, então duas calculadoras nunca disparam juntas.
let proxima = 0;
// L10c-1 (Riff): só a consulta iniciada por último grava o CEP na sessão; instâncias que saíram do DOM (o cart.js troca
// o corpo do drawer) são canceladas e não fazem POST, não aplicam resultado e não gravam nada.
let escolha = 0;
const vivas = new Map();
let gavetaAberta = false;
// o cart.js troca o corpo do drawer a cada mudança: a calculadora aberta reabre (e recalcula com o carrinho novo)
document.addEventListener('cr:cart:html', () => setTimeout(() => {
  for (const [r, cancela] of vivas) if (!r.isConnected) { cancela(); vivas.delete(r); }
  const d = document.querySelector('details[data-cr-frete]:not([data-pronto])'); if (d && gavetaAberta) d.open = true;
}));
// L2a: a barra de frete grátis da PDP (snippets/frete-barra-pdp) acompanha o carrinho pelo data-frete-falta da barra do
// drawer (o mesmo total da fórmula da Yampi), sem requisição nova. Aqui e não no core.js (teto de 3 KB). L2a-1 (Riff): a
// barra emite o próprio <script type="module"> deste arquivo (mesma URL do frete-cep: executa uma vez), então o atualizador
// existe também sem a calculadora (moletom na RN, produto sem SKU). Um cr:cart:html anterior à execução do módulo não se
// perde: ao carregar, a barra lê a do drawer que já estiver no DOM (o corpo que esse evento trouxe).
function barraPdp(fonte) {
  const fb = document.querySelector('[data-cr-frete-barra]'), b = fonte?.querySelector?.('[data-cr-trio]'), f = b?.dataset.freteFalta;
  if (!fb || !f) return;
  fb.hidden = b.dataset.estado === 'E0';
  fb.firstElementChild.textContent = +f ? fb.dataset.tFalta.replace('FFF', (f / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })) : fb.dataset.tChegou;
  fb.querySelector('span').style.setProperty('--p', 1 - f / fb.dataset.limiar);
}
// L2b: a linha do trio da PDP (snippets/trio-carrinho-pdp) pelo JSON data-cr-trio-itens do drawer: n = soma das
// quantidades das camisetas do kit, sem as da coleção de oversized (data-ov); n = k − 2 → pdp_1, k − 1 → pdp_2, ≥ k → ativo.
function trioPdp(fonte) {
  const el = document.querySelector('[data-cr-trio-carrinho]'), j = fonte?.querySelector?.('[data-cr-trio-itens]');
  if (!el || !j) return;
  const d = el.dataset, k = +d.k;
  const n = JSON.parse(j.textContent || '[]').reduce((s, i) => s + (d.ov && (i.c || '').split(',').includes(d.ov) ? 0 : i.q), 0);
  el.textContent = n >= k ? d.t3 : n === k - 1 ? d.t2 : n && n === k - 2 ? d.t1 : '';
  el.hidden = !el.textContent;
}
const doCarrinho = (fonte) => { barraPdp(fonte); trioPdp(fonte); };
document.addEventListener('cr:cart:html', ({ detail }) => doCarrinho(detail));
doCarrinho(document.querySelector('[data-cr-gaveta]'));
for (const r of document.querySelectorAll('[data-cr-frete]:not(details)')) iniciar(r);

export function iniciar(raiz) {
  if (raiz.dataset.pronto) return;
  raiz.dataset.pronto = 1;
  const carrinho = raiz.dataset.modo === 'carrinho';
  if (carrinho) { gavetaAberta = true; raiz.addEventListener('toggle', () => { gavetaAberta = raiz.open; }); }
  const dados = JSON.parse(raiz.querySelector('[data-cr-frete-dados]')?.textContent || '{}');
  const T = dados.textos || {};
  const variantes = dados.variantes || {};
  const endpoint = raiz.dataset.endpoint;
  const form = raiz.querySelector('form');
  const campo = raiz.querySelector('input[name="cep"]');
  const botao = raiz.querySelector('button');
  const status = raiz.querySelector('.cr-frete__status');
  const lista = raiz.querySelector('.cr-frete__lista');
  const nota = raiz.querySelector('.cr-frete__nota');
  // LM-F que acompanha a linha "Frete grátis": no carrinho, sempre; na PDP, só com o texto de frete desligado (ligado, a
  // LM-F fixa já está à vista). Condição A do Gancho no L10l
  const lmf = raiz.querySelector('[data-cr-frete-lmf]');
  const semL = raiz.querySelector('[data-cr-frete-semloggi]'); // FR-09 (L10l)
  const pdp = carrinho ? null : document.getElementById('cr-pdp-form');
  const intervalo = raiz.dataset.intervalo ? Number(raiz.dataset.intervalo) : 3000;
  const CHAVE = 'cr_frete_cep';
  let seq = 0;
  let ctl = null;
  let ultimo = '';
  let ultimaVariante = '';

  const digitos = (v) => (v || '').replace(/\D/g, '').slice(0, 8);
  const mascara = (v) => { const d = digitos(v); return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d; };
  const moeda = (c) => (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const varianteAtual = () => (pdp?.querySelector('input[name="id"]:checked') || pdp?.querySelector('input[type="hidden"][name="id"]'))?.value || '';
  // a PDP não tem campo de quantidade: a cotação é de 1 peça. Se um campo entrar, ler aqui e escutar input/change.

  // nos: <template> cujo conteúdo vai para a região viva (frase com link: snippets/frete-sem-opcoes, AUD-J)
  function aviso(txt, erro, nos) { if (nos) status.replaceChildren(nos.content.cloneNode(true)); else status.textContent = txt || ''; status.classList.toggle('is-erro', !!erro); status.classList.remove('visually-hidden'); }
  function limpar() { lista.hidden = true; lista.replaceChildren(); nota.hidden = true; if (semL) semL.hidden = true; lmf?.setAttribute('hidden', ''); }
  function cancelar() { seq += 1; ctl?.abort(); ctl = null; botao.disabled = false; return seq; }
  vivas.set(raiz, cancelar);

  // L2b (decisão de Henrique, 23/10, decisoes/2026-10-23-calculadora-2-mais-baratos.md, adendo): UMA linha, a opção mais
  // barata (empate: menor prazo), com o rótulo do tema (Econômico, ou "Frete grátis" quando a fonte devolve R$ 0) e o prazo;
  // a nota abaixo diz que as outras opções aparecem no checkout. Antes (copy 10f): Econômico + Expresso, a mais rápida.
  // prazo_dias null (fonte não informou) mostra "prazo no checkout" (FR-06; ajuste B do Gancho no L10a).
  const dias = (o) => (Number.isInteger(o.prazo_dias) ? o.prazo_dias : Infinity);
  // AUD-G3 (L10w): dias somados só no prazo exibido (e no aria, que lê o texto); dias() compara o prazo cru
  // shortcut: 1 é o manuseio da Yampi até o Hub devolver prazo_adicional_dias (v4.1); depois vale o da resposta
  let adic;
  // span com classe e texto (nome, prazo e valor da linha)
  const span = (c, t) => Object.assign(document.createElement('span'), { className: c, textContent: t });
  // FR-05 (L10l): a linha grátis leva o nome do serviço (Loggi Econômico) antes do prazo e fica sem valor
  function linha(rotulo, o, destaque, gratis) {
    const li = document.createElement('li'); li.className = `cr-frete__item${destaque ? ' is-destaque' : ''}`;
    const esq = document.createElement('span');
    const n = o.prazo_dias + adic; // L10w rev. 2 (Fiscal): 0 + 0 também é "até 1 dia útil", nunca "até 0 dias"
    esq.append(span('cr-frete__nome', rotulo), span('cr-frete__prazo', (gratis ? `${T.loggi} · ` : '') + (dias(o) === Infinity ? T.prazoCheckout : n <= 1 ? T.prazo1 : (T.prazoN || '').replace('NNN', n))));
    li.append(esq, span('cr-frete__valor', gratis ? '' : moeda(o.valor))); lista.append(li);
  }
  // FR-07: a região viva lê as linhas inteiras, do estado ATUAL da lista (também depois do FR-05 entrar ou sair);
  // o texto fica só para leitor de tela (a lista já está na tela). Sem anúncio repetido se nada mudou.
  function anunciar() {
    const sel = (li, c) => li.querySelector(c).textContent;
    const txt = `${(T.aria || '').replace('CCC', mascara(ultimo))} ${[...lista.children].map((li) => [sel(li, '.cr-frete__nome'), sel(li, '.cr-frete__valor'), sel(li, '.cr-frete__prazo')].filter(Boolean).join(', ')).join('; ')}.`;
    if (status.textContent !== txt) aviso(txt);
    status.classList.add('visually-hidden');
  }

  // L10l (AUD-H; copy 10j FR-05/FR-09): quem zera é a regra da conta Frenet (a mesma da Yampi), só na Loggi Econômico. O
  // tema não decide gratuidade: "Frete grátis" só na linha da Loggi Econômico que a fonte devolve com valor 0 (nunca
  // pela comparação com o limiar, nunca "a mais barata"). Sem a Loggi na resposta, com texto de frete ligado: FR-09.
  const loggi = (o) => /loggi/i.test(`${o.transportadora} ${o.servico}`) && /econ/i.test(o.servico);
  function mostrar(opcoes) {
    limpar(); // estado zerado: sem opções = sem FR-09 ("opções abaixo")
    if (!opcoes.length) { aviso(T.semOpcoes, 0, raiz.querySelector('[data-cr-frete-semop]')); return; }
    // a Loggi Econômico a R$ 0 é a econômica mesmo empatada com outra a R$ 0 (nome e prazo da que é grátis de fato)
    const zero = opcoes.find((o) => o.valor === 0 && loggi(o));
    const eco = zero || opcoes.reduce((a, o) => (o.valor < a.valor || (o.valor === a.valor && dias(o) < dias(a)) ? o : a));
    linha(zero ? T.gratis : T.eco, eco, true, !!zero);
    if (semL && !opcoes.some(loggi)) semL.hidden = false; // o FR-09 só existe no HTML com o texto de frete ligado
    lmf?.toggleAttribute('hidden', !zero);
    lista.hidden = false; nota.hidden = false;
    anunciar();
  }

  // L2a: a PDP não lê o carrinho (nem a seção do drawer) e não recota quando ele muda: a cotação é só da peça.

  async function calcular(cep) {
    const id = cancelar();
    limpar();
    if (cep.length !== 8 || cep === '00000000') { campo.setAttribute('aria-invalid', 'true'); aviso(T.cepInvalido, true); return; }
    campo.removeAttribute('aria-invalid');
    // sem tamanho escolhido (a PDP abre sem pré-seleção), cota 1 peça com a 1ª variante com SKU (peso dela). Escolher o
    // tamanho depois refaz a cotação com o peso da variante escolhida (observador abaixo).
    const vid = varianteAtual();
    const v = variantes[vid] || Object.values(variantes).find((x) => x.sku);
    ultimaVariante = vid;
    const qtd = 1;
    // contrato v4 (decisão de Henrique, 17/10; hub/frete-proxy/CONTRATO.md): cada item com SKU (obrigatório), qtd, valor
    // por unidade em centavos e peso_g = peso real da variante em gramas (0 quando não cadastrado: o Hub usa a queda).
    // Drawer: os itens do carrinho. PDP (L2a): só esta peça.
    const itens = carrinho ? dados.itens || [] : v ? [{ sku: v.sku, qtd, peso_g: v.peso_g || 0, valor: v.valor }] : [];
    if (!itens.length || itens.some((i) => !i.sku)) { aviso(T.erroFonte, true); return; }
    ultimo = cep;
    const minha = ++escolha;
    aviso(T.calculando);
    ctl = new AbortController();
    botao.disabled = true;
    let prazo;
    try {
      // subtotal = valor declarado: no drawer, o total efetivo que o Liquid traz; na PDP (L2a), o preço cheio da peça
      const subtotal = carrinho ? dados.total : v.valor * qtd;
      // L10a-r4-1 (Riff): a vez é conferida de novo a cada despertar (timer atrasado, página suspensa): se outra consulta
      // enviou nesse meio-tempo, espera outra vez. Sem await entre a conferência e a marcação: um envio por vez.
      for (let t; (t = proxima - Date.now()) > 0;) {
        await new Promise((ok) => setTimeout(ok, t));
        if (id !== seq || !raiz.isConnected) return;
      }
      proxima = Date.now() + intervalo;
      prazo = setTimeout(() => ctl?.abort(), 8000);
      const r = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, credentials: 'omit', signal: ctl.signal,
        body: JSON.stringify({ cep, itens, subtotal }) });
      const j = await r.json().catch(() => null);
      if (id !== seq || !raiz.isConnected) return;
      if (r.ok && j && Array.isArray(j.opcoes)) {
        const opcoes = j.opcoes.filter((o) => o && Number.isInteger(o.valor) && o.valor >= 0);
        adic = j.prazo_adicional_dias;
        if (adic >>> 0 !== adic) adic = 1; // só inteiro >= 0 (sem o campo: 1)
        mostrar(opcoes);
        if (minha === escolha) try { sessionStorage.setItem(CHAVE, cep); } catch { /* sem armazenamento */ }
      } else {
        // F-08 única (AUD-J, L10m; copy §5.5): uma situação, uma frase. 400 cep_invalido → CEP inválido; 429 → muitas;
        // 422 fora_da_faixa com mais de 50 peças → F-10; todo o resto (422 peso/dimensões/faixa, 502, 503, outros status,
        // rede, prazo de 8 s, JSON quebrado) → a genérica, sem "Tente de novo"
        const inv = j?.erro === 'cep_invalido';
        if (inv) campo.setAttribute('aria-invalid', 'true');
        aviso(inv ? T.cepInvalido : r.status === 429 ? T.muitas : j?.erro === 'fora_da_faixa' && itens.reduce((s, i) => s + i.qtd, 0) > 50 ? T.muitasPecas : T.erroFonte, !0);
      }
    } catch {
      if (id === seq) aviso(T.erroFonte, true);
    } finally {
      clearTimeout(prazo);
      if (id === seq) { ctl = null; botao.disabled = false; }
    }
  }

  campo.addEventListener('input', () => {
    const m = mascara(campo.value); if (m !== campo.value) campo.value = m;
    if (digitos(campo.value) !== ultimo) { cancelar(); limpar(); aviso(''); ultimo = ''; }
    campo.removeAttribute('aria-invalid');
  });
  // B4: "Calcular" com o MESMO CEP já cotado na tela, em curso ou agendado não cota de novo (o CEP lembrado já calculou ao
  // abrir; o clique repetido não gasta outra consulta). Depois de erro, ou com CEP novo, cota.
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const cep = digitos(campo.value);
    if (cep === ultimo && (ctl || !lista.hidden)) return;
    calcular(cep);
  });

  // troca de variante (peso e preço podem mudar): o product.js marca o rádio pelo atributo "checked" depois da SRA.
  // Seleção vazia (cor nova sem o tamanho, L5-1): invalida já o resultado e a consulta pendente; recalcula só quando
  // uma variante válida voltar.
  if (pdp) {
    new MutationObserver(() => {
      const vid = varianteAtual();
      if (vid === ultimaVariante) return;
      ultimaVariante = vid;
      if (!vid) { cancelar(); limpar(); aviso(''); return; }
      if (ultimo && digitos(campo.value) === ultimo) calcular(ultimo);
    }).observe(pdp, { subtree: true, attributes: true, attributeFilter: ['checked', 'value'], childList: true });
  }

  // CEP lembrado na sessão: preenche e calcula em tempo ocioso; desiste se o cliente já mexeu
  let salvo = '';
  try { salvo = digitos(sessionStorage.getItem(CHAVE)); } catch { /* sem armazenamento */ }
  if (salvo.length === 8 && !campo.value) {
    campo.value = mascara(salvo);
    const inicio = seq;
    const rodar = () => (window.requestIdleCallback || ((f) => setTimeout(f, 200)))(() => { if (seq === inicio && digitos(campo.value) === salvo) calcular(salvo); });
    if (document.readyState === 'complete') rodar(); else window.addEventListener('load', rodar, { once: true });
  }
}
